'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../../_virtual/_rollupPluginBabelHelpers.js');
var cc = _interopDefault(require('classcat'));
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_8 = require('../../hooks/useMergedState.js');
var styles = _interopDefault(require('./image.module.scss'));

Image.defaultProps = {
  alt: '',
  fadeIn: true
};

function Image(props) {
  var placeholder = props.placeholder,
      width = props.width,
      noWidth = props.noWidth,
      height = props.height,
      aspectRatio = props.aspectRatio,
      srcSetWebpProp = props.srcSetWebp,
      srcSetProp = props.srcSet,
      srcProp = props.src,
      sizes = props.sizes,
      alt = props.alt,
      style = props.style,
      contain = props.contain,
      className = props.className,
      _props$removePlacehol = props.removePlaceholderOnLoad,
      removePlaceholderOnLoad = _props$removePlacehol === void 0 ? false : _props$removePlacehol;
  var ref = React.useRef(null);
  var srcSet = createSrcSetString(srcSetProp);
  var srcSetWebp = createSrcSetString(srcSetWebpProp);

  var _useMergedState = __chunk_8.useMergedState(getInitialState(props)),
      _useMergedState2 = __chunk_1.slicedToArray(_useMergedState, 2),
      state = _useMergedState2[0],
      setMergedState = _useMergedState2[1];

  var isVisible = state.isVisible,
      IOSupported = state.IOSupported,
      imgLoaded = state.imgLoaded,
      hasNoScript = state.hasNoScript;
  React.useEffect(function () {
    if (IOSupported && ref.current) {
      listenToIntersections(ref.current, function () {
        setMergedState({
          isVisible: true,
          imgLoaded: inImageCache(props)
        });
      });
    }
  }, []);

  function handleImageLoad() {
    setInImageCache(props);
    setMergedState({
      imgLoaded: true
    });
  }

  var wrapperStyle = __chunk_1.objectSpread({}, style);

  if (placeholder) {
    wrapperStyle.backgroundImage = imgLoaded === true && removePlaceholderOnLoad === true ? '' : "url(".concat(placeholder, ")");
  }

  if (width) {
    wrapperStyle.width = width;
  } else if (!noWidth) {
    wrapperStyle.width = '100%';
  }

  var spanStyle = {
    display: 'block',
    width: '100%',
    height: 0
  };

  if (height !== undefined) {
    wrapperStyle.height = height;

    if (aspectRatio && typeof height === 'string' && height.indexOf('px') !== -1 && !width) {
      wrapperStyle.width = "".concat(parseInt(height) * aspectRatio, "px");
    }
  } else if (aspectRatio) {
    spanStyle.paddingTop = "".concat(1 / aspectRatio * 100, "%");
  } else {
    wrapperStyle.height = '100%';
  }

  var imgStyle = {
    opacity: imgLoaded ? 1 : 0
  };
  var imgProps = {
    srcSet: srcSet,
    src: srcProp || srcSetProp && (typeof srcSetProp === 'string' ? '' : Object.values(srcSetProp).pop()),
    sizes: sizes,
    className: styles.img,
    style: imgStyle,
    alt: alt
  };
  return React__default.createElement("figure", {
    className: cc([styles.wrapper, className, contain && styles.contain]),
    style: wrapperStyle,
    ref: ref
  }, React__default.createElement("span", {
    style: spanStyle
  }), isVisible && React__default.createElement("picture", null, srcSetWebp && React__default.createElement("source", {
    type: "image/webp",
    srcSet: srcSetWebp,
    sizes: sizes
  }), React__default.createElement("img", Object.assign({}, imgProps, {
    onLoad: handleImageLoad
  }))), hasNoScript && React__default.createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: noscriptImg(props, imgProps, {
        srcSet: srcSet,
        srcSetWebp: srcSetWebp
      })
    }
  }));
}

function noscriptImg(props, imgProps, _ref) {
  var srcSet = _ref.srcSet,
      srcSetWebp = _ref.srcSetWebp;
  // Check if prop exists before adding each attribute to the string output below to prevent
  // HTML validation issues caused by empty values like width="" and height=""
  var src = imgProps.src ? "src=\"".concat(imgProps.src, "\" ") : "src=\"\" "; // required attribute

  var sizes = props.sizes ? "sizes=\"".concat(props.sizes, "\" ") : "";
  var srcSetWebpTag = srcSetWebp ? "<source type='image/webp' srcset=\"".concat(srcSetWebp, "\" ").concat(sizes, "/>") : "";
  var srcSetAttr = srcSet ? "srcset=\"".concat(srcSet, "\" ") : "";
  var alt = props.alt ? "alt=\"".concat(props.alt, "\" ") : "alt=\"\" "; // required attribute

  return "<picture>".concat(srcSetWebpTag, "<img ").concat(sizes).concat(srcSetAttr).concat(src).concat(alt, " class=\"").concat(imgProps.className, "\" style=\"opacity: 1\" /></picture>");
}

function getInitialState(props) {
  var fadeInProp = props.fadeIn,
      critical = props.critical; // default settings for browser without Intersection Observer available

  var isVisible = true;
  var imgLoaded = false;
  var IOSupported = false;
  var fadeIn = fadeInProp; // If this image has already been loaded before then we can assume it's
  // already in the browser cache so it's cheap to just show directly.

  var seenBefore = inImageCache(props); // browser with Intersection Observer available
  // @ts-ignore

  if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
    isVisible = false;
    IOSupported = true;
  } // Never render image during SSR


  if (typeof window === "undefined") {
    isVisible = false;
  } // Force render for critical images


  if (props.critical) {
    isVisible = true;
    imgLoaded = true;
    IOSupported = false;
  }

  var hasNoScript = !(critical && !fadeIn);
  return {
    isVisible: isVisible,
    imgLoaded: imgLoaded,
    IOSupported: IOSupported,
    fadeIn: fadeIn,
    hasNoScript: hasNoScript,
    seenBefore: seenBefore
  };
} // UTILS


var imageCache = {};

function inImageCache(props) {
  return imageCache[props.srcSet || props.src] || false;
}

function setInImageCache(props) {
  imageCache[props.srcSet || props.src] = true;
} // const IOSupported = typeof window !== 'undefined' && window.IntersectionObserver;


function createSrcSetString(srcSet) {
  if (srcSet === undefined || typeof srcSet === 'string') return srcSet;
  return Object.keys(srcSet).map(function (width) {
    return "".concat(srcSet[width], " ").concat(width, "w");
  }).join(',');
}

var io;
var listeners = [];

function listenToIntersections(el, cb) {
  getIO().observe(el);
  listeners.push([el, cb]);
}

function getIO() {
  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
    io = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        listeners.forEach(function (l) {
          if (l[0] === entry.target) {
            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              io.unobserve(l[0]);
              l[1]();
            }
          }
        });
      });
    }, {
      rootMargin: "200px"
    });
  }

  return io;
}

exports.Image = Image;
